const StaffChatMessage = ({message}) => {
    return (
        <div className="adminChatMessage">
            <p className="text-glmagenta-400 adminChatText">[{new Date(message.time).toISOString().split("T")[1].split(".")[0]}]</p>
            <p className="text-glwhite-500 adminChatText">{message.nickName} ({message.userId}):</p>
            <p>{message.message.replace(/^@+/, '')}</p>
        </div>
    )
}

export default StaffChatMessage;